var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('HyFLoader'):(_vm.error)?_c('div',{staticClass:"llegada-error"},[_c('p',[_vm._v(_vm._s(_vm.error))])]):_c(_vm.formulario,{tag:"component",attrs:{"precargado":_vm.datos}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }